// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tPBf","label":"styles_label__2rFgJ"};